import ecomInterceptor from "../interceptors/ecomInterceptor";

const usersService = {
  getUserById: async (id?: string): Promise<any> => {
    try {
      const response = await ecomInterceptor.get(`/users`);
      return response.data?.data || response.data;
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error.message ||
        "Failed to fetch user by ID";
      throw new Error(`getUserById error: ${message}`);
    }
  },

  updateUser: async (data: any): Promise<any> => {
    const payload = {
      phone: data.phoneNumber,
    };
    try {
      const response = await ecomInterceptor.put(`/users`, payload);
      return response.data?.data || response.data;
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error.message ||
        "Unable to update user";
      throw new Error(`updateUser error: ${message}`);
    }
  },

  deleteUser: async (): Promise<any> => {
    try {
      const response = await ecomInterceptor.delete(`/users`);
      return response.data?.data || response.data;
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error.message ||
        "Unable to delete user";
      throw new Error(`deleteUser error: ${message}`);
    }
  },
};

export default usersService;
